module.exports = "https://deal-img.imgix.net/consumer/modern/ratings.9b12fc88.png";